import "./MarginQuizDialog.scss";
import {IModalService} from "angular-ui-bootstrap";
import {MarginQuizDialogController} from "./MarginQuizDialogController";

export class MarginQuizService {

    public static id = "marginQuizService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {
    }

    public async open(): Promise<void> {
        const instance = this.$uibModal.open({
            templateUrl: "app/quiz/margin/service/MarginQuizDialog.html",
            backdrop: "static",
            size: "xl",
            windowClass: "margin-quiz-dialog",
            controller: MarginQuizDialogController,
            controllerAs: "ctrl"
        });
        return instance.result;
    }
}
